import { useState, useEffect } from 'react';
import '../App.css';

function ProgressBar({...properties}){
    const [progressClass, setProgressClass] = useState("progressBar");
    const [shadowClass, setShadowClass] = useState("shadowProgressBar");

    useEffect(() => {
        if (properties.constrainHighlights){
            var shadowWidth = (properties.shadowCount / properties.maxWordCount) * 100;
            var progressWidth = (properties.progressCount / properties.maxWordCount) * 100;

            if (shadowWidth >= 80){
                setShadowClass("shadowProgressBar shadowProgressBarApproachingLimit");
            }
            else {
                setShadowClass("shadowProgressBar");
            }

            if (progressWidth >= 80){
                setProgressClass("progressBar progressBarApproachingLimit");
            }
            else {
                setProgressClass("progressBar");
            }
        }

    }, [properties.shadowCount, properties.progressCount, properties.maxWordCount]);

    return (
        <div id="progress" className="progressParent">
            <div id="progressBar" className={progressClass} style={{width: (properties.progressCount / properties.maxWordCount) * 100 + "%"}}></div>
            <div id="shadowProgressBar" className={shadowClass} style={{width: (properties.shadowCount / properties.maxWordCount) * 100 + "%"}}></div>
        </div>
    );
}

export default ProgressBar;